export const CREATE_PAYROLL_DEDUCTION = "CREATE_PAYROLL_DEDUCTION";
export const FETCH_PAYROLL_DEDUCTIONS = "FETCH_PAYROLL_DEDUCTIONS";
export const EDIT_PAYROLL_DEDUCTION = "EDIT_PAYROLL_DEDUCTION";
export const DELETE_PAYROLL_DEDUCTION = "DELETE_PAYROLL_DEDUCTION";
